export const loadReCAPTCHAv3 = (siteKey) => {
    return new Promise((resolve, reject) => {
        if (window.grecaptcha) return resolve(window.grecaptcha);

        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        script.onload = () => resolve(window.grecaptcha);
        script.onerror = () => reject('Failed to load reCAPTCHA');
        document.body.appendChild(script);
    });
};
